import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {GamesLevelVocabularyComponent} from '../games-level-vocabulary/games-level-vocabulary.component';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {GameLevelService} from '../../../services/games/game-level/game-level.service';
import {GameGameService} from '../../../services/games/game-game/game-game.service';
import {PageService} from '../../../services/page/page.service';
import {MetaService} from '../../../services/meta/meta.service';
import {TranslateService, TranslateModule} from '@ngx-translate/core';
import {UserService} from '../../../services/user/user.service';
import { GameLevelLessonService } from 'src/app/services/games/game-level-lesson/game-level-lesson.service';
import { GameLevelCultureService } from 'src/app/services/games/game-level-culture/game-level-culture.service';
import { GamesLevelCulturesComponent } from '../games-level-cultures/games-level-cultures.component';
import { GamesLevelLessonsComponent } from '../games-level-lessons/games-level-lessons.component';
import {CommonModule} from '@angular/common';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {SortByPipe} from '../../../pipes/sort-by.pipe';
import {GameItemComponent} from '../../../components/games/game-item/game-item.component';

@Component({
  selector: 'app-games-theme-level',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent,
    GameItemComponent,
    RouterLink,
    SortByPipe
  ],
  templateUrl: './games-theme-level.component.html',
  styleUrls: ['./games-theme-level.component.scss']
})

export class GamesThemeLevelComponent implements OnInit, OnDestroy {

  loading = true;
  idTheme: string;
  idLevel: string;
  level: any;
  games: any;
  age: any;
  lessons: any;
  cultures: any;

  constructor(
    private route: ActivatedRoute,
    private modal: NgbModal,
    private levelSrc: GameLevelService,
    private gameSrc: GameGameService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private pageSrv: PageService,
    private metaSrv: MetaService,
    private translate: TranslateService,
    private userSrv: UserService,
    private levelLessonSrv: GameLevelLessonService,
    private levelCultureSrv: GameLevelCultureService
  ) { }

  async ngOnInit() {
    this.age = await this.userSrv.age();
    this.translate.get(`Chargement...`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.idTheme = this.route.snapshot.params.idTheme;
    this.idLevel = this.route.snapshot.params.idLevel;
    this.level = await this.levelSrc.findById(this.idLevel);
    this.lessons = await this.levelLessonSrv.findAllByLevel(this.level.uniqid);
    this.cultures = await this.levelCultureSrv.findAllByLevel(this.level.uniqid);
    // Check si le thème n'est pas restreint et que l'utilisateur a 18 ans ou plus
    if (this.level.minorRestriction && this.age.age <= 18) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes']);
      return;
    }
    if (!this.level) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'themes', this.idTheme]);
      return;
    }
    this.metaSrv.setMetas({title: this.level.name});
    if (!this.level.locked) {
      this.games = await this.gameSrc.findAllByLevel(this.idLevel);
    }
    this.pageSrv.displayPurpleMain = true;
    this.loading = false;
  }

  async ngOnDestroy() {
    this.pageSrv.displayPurpleMain = false;
  }

  async openVocabulary() {
    const modal = this.modal.open(GamesLevelVocabularyComponent, {
      size: 'lg', centered: true, scrollable: true
    });
    modal.componentInstance.level = this.level;
  }

  trackById(index: number, item: any) { return item.id; }

  getTrainingGames() {
    return this.games.filter((game: any) => !game.checkResult);
  }

  getClassicGames() {
    return this.games.filter((game: any) => game.checkResult);
  }

  async openGame(idGame: string) {
    await this.router.navigate([
      '/',
      this.langSrcSrv.current.shortCode,
      'themes',
      this.idTheme,
      this.idLevel,
      idGame
    ]);
  }

  async openCultures() {
    const modal = this.modal.open(GamesLevelCulturesComponent, {
      size: 'lg', centered: true, scrollable: true
    });
    modal.componentInstance.level = this.level;
    modal.componentInstance.cultures = this.cultures;
  }

  async openLessons() {
    const modal = this.modal.open(GamesLevelLessonsComponent, {
      size: 'lg', centered: true, scrollable: true
    });
    modal.componentInstance.level = this.level;
    modal.componentInstance.lessons = this.lessons;
  }
}
